import { Injectable } from '@angular/core';
import {createAuthorizationHeader} from "../../utils/headers";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {GlobalService} from "../../global.config";
import {DateInterval} from "../../model/date-interval.model";
import {DatePipe} from "@angular/common";

@Injectable({
  providedIn: 'root'
})
export class TechnicalDataService {

  constructor(
    private _http: HttpClient,
    private globalService: GlobalService,
    private datePipe: DatePipe,
    ) { }

  getDeviceOpt(deviceId: number): Observable<any> {
    let headers = createAuthorizationHeader();
    return this._http
      .get(this.globalService.dns + 'deviceopt/' + deviceId, { headers: headers });
  }
  getDeviceCarb(deviceId: number): Observable<any> {
    let headers = createAuthorizationHeader();
    return this._http
      .get(this.globalService.dns + 'devicecarb/' + deviceId, { headers: headers });
  }
  getRepFuelVariation(
    deviceId: number,
    dateInterval: DateInterval
  ): Observable<any> {
    let headers = createAuthorizationHeader();
    return this._http
      .post(this.globalService.dns + 'repfuelvariation/' + deviceId, dateInterval, {
        headers: headers
      });
  }
  getFuelDetail(
    deviceId: number,
    dateInterval: DateInterval,
    options: any
  ): Observable<any> {
    let headers = createAuthorizationHeader();
    return this._http
      .post(
        this.globalService.dns + 'fuels/details/' + deviceId + '?options=' + options,
        dateInterval,
        { headers: headers }
      );
  }
  getListFuelingDate(vehiculeId: number, startDate: Date, endDate: Date): Observable<any> {
    let headers = createAuthorizationHeader();
    return this._http
      .get(this.globalService.dns + "fuelings/listFueling?vehiculeId=" + vehiculeId + "&startDate=" + this.datePipe.transform(startDate, "yyyy-MM-dd HH:mm:ss") + "&endDate= " + this.datePipe.transform(endDate, "yyyy-MM-dd HH:mm:ss"), { headers: headers });
  }

  getFuelDetailCarb(
    deviceId: number,
    dateInterval: DateInterval,
    options: any
  ): Observable<any> {
    let headers = createAuthorizationHeader();
    return this._http
      .post(
        this.globalService.dns + 'fuels/detailsCarb/' + deviceId + '?options=' + options,
        dateInterval,
        { headers: headers }
      );
  }
  exportFuelsData(
    fuelsData,
    groupName,
    startDate,
    endDate,
    vehicule: string
  ): Observable<any> {
    let headers = createAuthorizationHeader();
    return this._http
      .post(
        this.globalService.dns +
        "fuelsData?groupName=" +
        groupName +
        "&startDate=" +
        startDate +
        "&endDate=" +
        endDate +
        "&vehicule=" +
        vehicule +
        "&timeDiff=" +
        this.globalService.time_difference,
        fuelsData.reverse(),
        { headers: headers, responseType: 'blob' as 'json' }
      );
  }
}
